export class AnalyticsBase {
  private isEnabled = false;

  private enableCondition: () => boolean;

  isInitialized = false;

  constructor() {
    this.enableCondition = () => false;
  }

  checkEnabled() {
    this.isEnabled = this.enableCondition();
    return this.isEnabled;
  }

  setEnableCondition(condition: () => boolean) {
    this.enableCondition = condition;
  }

  enable() {
    this.isEnabled = true;
  }

  disable() {
    this.isEnabled = false;
  }

  isReady() {
    return this.isInitialized;
  }
}
